import { NarrativeTemplate } from './templates'

export const fleetTemplates: NarrativeTemplate[] = [
  // Critical situation
  {
    id: 'fleet-critical',
    category: 'fleet',
    condition: (data) => Number(data.criticalAssets) > 0,
    priority: 100,
    template: `ATTENTION REQUIRED: Your fleet health is at {healthScoreFormatted}. {criticalAssets} asset(s) are in critical condition requiring immediate attention. {warningAssets} additional assets are showing warning signs.

Priority Actions:
• Address critical assets immediately to prevent unplanned downtime
• Review warning assets within the next 24-48 hours
• {anomaliesToday} anomalies detected today across the fleet`
  },

  // Warning situation
  {
    id: 'fleet-warning',
    category: 'fleet',
    condition: (data) => Number(data.criticalAssets) === 0 && Number(data.warningAssets) > 0,
    priority: 80,
    template: `Your fleet health is at {healthScoreFormatted}. While no assets are critical, {warningAssets} asset(s) require attention within 48 hours.

Current Status:
• {healthyAssets} of {totalAssets} assets operating normally
• Fleet trend is {trendDescription}
• {anomaliesToday} anomalies detected today

Recommendation: Schedule preventive inspections for warning assets to maintain optimal fleet performance.`
  },

  // Healthy fleet
  {
    id: 'fleet-healthy',
    category: 'fleet',
    condition: (data) => Number(data.criticalAssets) === 0 && Number(data.warningAssets) === 0,
    priority: 60,
    template: `Excellent! Your fleet health is at {healthScoreFormatted}. All {totalAssets} assets are operating within normal parameters.

Fleet Status:
• Overall trend: {trendDescription}
• Anomalies today: {anomaliesToday}
• All systems nominal

Continue monitoring and maintain current maintenance schedules for optimal performance.`
  },

  // Improving trend
  {
    id: 'fleet-improving',
    category: 'fleet',
    condition: (data) => data.trendDescription === 'improving' || data.trendDescription === 'significantly improving',
    priority: 50,
    template: `Positive Trend: Fleet health is {trendDescription} at {healthScoreFormatted}.

This improvement indicates:
• Maintenance actions are effective
• Predictive interventions are working
• Asset reliability is increasing

Keep up the proactive maintenance approach.`
  },

  // Default
  {
    id: 'fleet-default',
    category: 'fleet',
    priority: 10,
    template: `Fleet Overview: {healthScoreFormatted} overall health across {totalAssets} assets.

• Healthy: {healthyAssets}
• Warning: {warningAssets}
• Critical: {criticalAssets}
• Anomalies Today: {anomaliesToday}`
  }
]
